module.exports = __webpack_public_path__ + "img/0Q3A4053_FoamcoreMatted.b84a9a5d.jpg";